/**
 * Membership role DISPLAY metadata (frontend-only). The role catalogue and the
 * "owner is not invitable/assignable" rule are owned by the backend and consumed at
 * runtime: role labels come from `useOptionLabels('membership_role')` and the invitable
 * subset from `useOptionGroup('invitable_role')` (GET /metadata/options/). This file
 * keeps only the pieces the backend does not own — the chip palette, the downgrade
 * rank, and the per-role descriptive copy from the .pen frames.
 *
 * See `useInvitableRoles` / `useAssignableRoles` in pages/Settings/bits.jsx, which
 * join these descriptions to the server-driven invitable-role list.
 */

/** Role chip palette per the .pen Team frame: Owner=indigo, Manager=emerald,
 * Lister=amber, Viewer=neutral. */
const ROLE_CHIP = {
  owner: 'bg-primary/15 text-primary',
  manager: 'bg-success/15 text-success',
  lister: 'bg-warning/15 text-warning',
  viewer: 'bg-surface-2 text-ink-muted',
};

/** Role rank for downgrade detection (owner highest). */
const ROLE_RANK = { owner: 3, manager: 2, lister: 1, viewer: 0 };

/** Per-role descriptive copy (.pen Invite Modal / Team legend). Display-only; the
 * set of *invitable* roles is server-driven (owner is excluded there, never here). */
const ROLE_DESCRIPTIONS = {
  owner: 'Full access. Set by ownership transfer, not invite.',
  manager: 'Runs operations — everything except billing & danger zone.',
  lister: 'Adds & lists parts. Cannot see financials (ROI, revenue).',
  viewer: 'Read-only access across the app.',
};

export {
  ROLE_CHIP,
  ROLE_DESCRIPTIONS,
  ROLE_RANK,
};
